__turbopack_context__.v({
  "eyebrow": "ReservationOfferCardCZ-module__FnXsMW__eyebrow" + " " + __turbopack_context__.i(856880)["eyebrow"],
  "infoRow": "ReservationOfferCardCZ-module__FnXsMW__infoRow" + " " + __turbopack_context__.i(856880)["infoRow"],
  "infoTitle": "ReservationOfferCardCZ-module__FnXsMW__infoTitle" + " " + __turbopack_context__.i(856880)["infoTitle"],
  "photoWrapper": "ReservationOfferCardCZ-module__FnXsMW__photoWrapper" + " " + __turbopack_context__.i(856880)["photoWrapper"],
  "styledTile": "ReservationOfferCardCZ-module__FnXsMW__styledTile" + " " + __turbopack_context__.i(856880)["styledTile"],
});
